alertController.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  '$sce',
  '$route',
  'translateFilter'
];

export function alertController($rootScope, $scope, $timeout, $sce, $route, translateFilter) {
  let TempTimeout = {error: 15000, warning: 6000, success: 3000};
  let controller = this;
  $scope.$rootScope = $rootScope;
  $scope.alerts = [
    /*
       { type: 'error', msg: 'Oh snap! Change a few things up and try submitting again.' },
       { type: 'success', msg: 'Well done! You successfully read this important alert message.' }
    */
  ];
  const minimalTimeout = 3000;

  let autoSaveAlert = {
    oMsg: '',
    msg: '',
    type: 'info',
    count: 1,
    stickType: 'temp',
    closeable: false
  };

  // stickType: permanent, temp, page
  // msg : string, type: (error,success,null), category: future..;)
  let addAlertIntern = function (msg, type, category, stickType, time, counter) {
    let alert = null;
    time = time || undefined;

    for (let i in $scope.alerts) {
      let a = $scope.alerts[i];
      if (a.oMsg === msg) {
        // originalmsg gleich
        alert = a;
        break;
      }
    }
    if (alert == null) {
      // new alert
      msg = $sce.trustAsHtml(msg);

      alert = {
        oMsg: msg,
        msg: msg,
        type: type,
        count: 1,
        stickType: stickType
      };
      $scope.alerts.push(alert);
    } else {
      if (counter) {
        alert.count += 1;
        msg = '(' + alert.count + 'x) ' + alert.oMsg;
      } else {
        msg = alert.oMsg;
      }

      msg = $sce.trustAsHtml(msg);
      alert.msg = msg;
    }
    if (alert.stickType === 'temp') {
      // if there is already an alert - cancel the older one
      if (alert.timeout !== undefined) {
        $timeout.cancel(alert.timeout);
      }
      if (!time) {
        if (type) time = TempTimeout[type.toLowerCase()];
        // if there is no time defined, use the minimal time;
        if (!time) time = minimalTimeout;
      }
      alert.timeout = $timeout(function () {
        alert.timeout = controller.closeAlert(alert);
      }, time);
    }
    return alert;
  };

  // add a permanent alert
  controller.addPermanentAlert = function (msg, type, category) {
    return addAlertIntern(msg, type, category, 'permanent', null, true);
  };

  // show alert with predefined timer
  controller.addTemporaryAlert = function (msg, type, category) {
    return addAlertIntern(msg, type, category, 'temp', null, true);
  };

  // show alert with individual timer
  controller.addTemporaryAlertWithCustomTimer = function (msg,
                                                          type,
                                                          category,
                                                          time) {
    return addAlertIntern(msg, type, category, 'temp', time, true);
  };

  // show alert with individual timer
  controller.addTemporaryAlertWithCustomTimerAndNoCounter = function (msg,
                                                          type,
                                                          category,
                                                          time) {
    return addAlertIntern(msg, type, category, 'temp', time, false);
  };

  // show alert as long as the actual page is active
  controller.addPageAlert = function (msg, type, category) {
    return addAlertIntern(msg, type, category, 'page');
  };

  controller.closeAlert = function (item) {
    $.arrayRemove($scope.alerts, item);
  };

  controller.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };

  controller.handleConnectionError = function (error, msg) {
    let is404 = error && error.status && error.status === 404;
    if (is404) {
      controller.addTemporaryAlert(
        msg ||
        translateFilter(
          'fe.common.notFound',
          'Resource konnte nicht gefunden werden'
        ),
        'warning'
      );
    } else {
      controller.addTemporaryAlert(
        msg ||
        translateFilter(
          'fe.common.error.connection',
          'Verbindungsfehler aufgetreten'
        )
      );
    }
  };

  /**
   * Show or resume the info that the app is saving changes to the
   * database. Can be called any time.
   */
  controller.startOrResumeAutoSaving = function () {
    autoSaveAlert.closeable = false;
    autoSaveAlert.msg = translateFilter(
      'fe.common.info.save.changes',
      'Änderungen speichern...'
    );
    if (alert.timeout !== undefined) {
      $timeout.cancel(alert.timeout);
      autoSaveAlert.timeout = undefined;
    }
    if ($scope.alerts.indexOf(autoSaveAlert) === -1) {
      $scope.alerts.push(autoSaveAlert);
    }
  };

  /**
   * Set the info, that the saving ist done. The user can close the info
   * alert - but it will alsow be closed after 3 seconds.
   */
  controller.autoSavingDone = function () {
    autoSaveAlert.msg = translateFilter(
      'fe.common.info.changes.saved',
      'Änderungen gesichert.'
    );
    autoSaveAlert.closeable = true;
    autoSaveAlert.timeout = $timeout(function () {
      autoSaveAlert.timeout = controller.closeAlert(autoSaveAlert);
    }, 500);
  };

  /**
   * Set the info that the entity has *not* been saved. The user can close the info
   * alert - but it will also be closed automatically after a while
   */
  controller.autoSavingNotDone = function () {
    autoSaveAlert.msg = translateFilter('fe.common.info.changes.not.saved');
    autoSaveAlert.closeable = true;
    autoSaveAlert.type = 'warning';
    autoSaveAlert.timeout = $timeout(function () {
      autoSaveAlert.timeout = controller.closeAlert(autoSaveAlert);
      autoSaveAlert.type = 'info';
    }, 5000);
  };

  $rootScope.handleMsgContext = function (context) {
    if (!context || !context.messages) return;
    for (let i in context.messages) {
      let msg = context.messages[i],
        msgText = null,
        msgImportance;
      if (msg.localeKey) msgText = translateFilter(msg.localeKey);
      if (!msgText && msg.key) {
        // key is not intended to be use as the localeKey, but as a marker to the controller
        // e.g. key="area" to signal some form field to which this message should be attached
        // nevertheless there are implementations that misuse it, hence this work around.
        let translated = translateFilter(msg.key);
        if (translated && translated !== msg.key) {
          msgText = translated;
          console.error(
            'Use localeKey instead of key to transport an error message!!'
          );
        }
      }
      // key might not have been set or might have no translation.
      if (!msgText && msg.value) msgText = translateFilter(msg.value);
      if (msgText) {
        switch (msg.type) {
          case 'INFO':
          case 'WARNING':
          case 'ERROR':
            msgImportance = msg.type.toLowerCase();
            break;
          default:
            msgImportance = 'warning';
            break;
        }
        $rootScope.alertController.addTemporaryAlert(msgText, msgImportance);
      }
    }
  };

  $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
    // remove alerts with sticky type 'page' on route, i.e. page, change
    for (let i in $scope.alerts) {
      let alert = $scope.alerts[i];
      if (alert.stickType === 'page') {
        controller.closeAlert(alert);
      }
    }
  });

  $rootScope.errors = controller; // todo: where to put erorr controlelr ?
  return ($rootScope.alertController = $scope.alertController = this);
}

